import { type SxProps, type Theme } from "@mui/material/styles";

/** The page shell shared by Preview and Configuration: sub-nav on top, content filling the rest. */
export const PAGE_SX: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  gap: 1.5,
  pt: 1.5,
  pl: 1.5,
  pr: 2.5,
  pb: 2.5,
  backgroundColor: theme.palette.background.default,
});
